let apiUrl = 'http://localhost:3001/v1';
if (window.location.href.indexOf('connect.thecrew') > -1) {
  apiUrl = 'https://connect.thecrew.be/api/v1';
} else if (window.location.href.indexOf('connect.allyours') > -1) {
  apiUrl = 'https://connect.allyours.be/api/v1';
} else if (window.location.href.indexOf('callcenter') > -1) {
  apiUrl = 'https://api.callcenter.m-sphere.be/v1';
}
export const API_URL = apiUrl;
export const URL_FILE_UPLOAD = `${API_URL}/importFile/upload`;
export const URL_FILE_IMPORT = `${API_URL}/importFile/import`;
export const URL_FILE_DOWNLOAD = `${API_URL}/projects/download`;
export const URL_PROJECT_EXPORT = `${API_URL}/projects/export`;
export const URL_PROJECT_REACTIVATE = `${API_URL}/projects/reactivate`;
export const URL_PROJECT_CONTACT_FIELDS = `${API_URL}/projects/fields`;
export const URL_AGENTS = `${API_URL}/users/agents`;
export const URL_USER_PROJECTS = `${API_URL}/users/projects`;
export const URL_CUSTOMERS = `${API_URL}/users/customers`;
export const URL_PROJECTS = `${API_URL}/projects`;
export const URL_USER_PROJECTS_CHANGE = `${API_URL}/users/projectsChange`;
export const URL_PROJECT_STATS = `${API_URL}/projects/stats`;
export const SIGNIN_URL = `${API_URL}/auth/signin`;
export const URL_REFRESH_TOKEN = `${API_URL}/auth/refresh_token`;
//export const API_URL = 'http://jsonplaceholder.typicode.com';

export const FIELDS_BUILT_IN = [
  'Script',
  'Info',
  'SDD',
  'IBAN',
  'BIC_CODE',
  'Increase',
  'Monthly Contribution'
];

export const DRAG_TYPE_FIELD = 'drag_type_field';



// WEBPACK FOOTER //
// ./src/constants.js